// Meta Pixel helper — safely injects the official Meta Pixel script
const PIXEL_ID = '4357796174441977'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

export const initMetaPixel = () => {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  try {
    // Inject the Meta Pixel base code as an inline script to avoid TS/runtime issues
    const inlineScript = document.createElement('script')
    inlineScript.text = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      if(s&&s.parentNode){s.parentNode.insertBefore(t,s)}else{b.head.appendChild(t)}}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${PIXEL_ID}');
      fbq('track', 'PageView');
    `
    document.head.appendChild(inlineScript)

    // Add noscript fallback
    const noscript = document.createElement('noscript')
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
    noscript.appendChild(img)
    document.body.appendChild(noscript)
  } catch (err) {
    // Fail silently — never break the app for analytics
    console.warn('Meta Pixel init failed:', err)
  }
}

export const trackEvent = (eventName: string, params?: Record<string, any>) => {
  if (typeof window === 'undefined') return
  try {
    if (!window.fbq) return
    if (params) {
      window.fbq('track', eventName, params)
    } else {
      window.fbq('track', eventName)
    }
  } catch (err) {
    console.warn('Meta Pixel track failed:', err)
  }
}
